export default __webpack_public_path__ + "static/video-bg-1a8662dd4a3d34853893241986cab3ea.jpg";